















































import store from '@/store';
import BaseMixin from '@/mixins/BaseMixin';
import { LoadingIndicator } from '@/components/loading-indicator/LoadingIndicator.tsx';
import RelatedPart from '@/components/related-part/RelatedPart.vue';
import SmoothReflow from '@/components/smooth-reflow/SmoothReflow.vue';

import { Component, Prop, Mixins } from 'vue-property-decorator';
import { RelatedPart as RelatedPartEntity } from '@/entities/RelatedPart';
import { RelatedPartsModuleTypes } from '@/store/modules/related-parts';
import { LoadingState } from '@/entities/LoadingState';
import { CloseIcon } from '@/components/icons/CloseIcon';
import { RelatedPartType } from '@/entities/RelatedPartType';

@Component({
    store,
    components: {
        LoadingIndicator,
        RelatedPart,
        SmoothReflow,
        CloseIcon,
    },
})
export default class RelatedParts extends Mixins(BaseMixin) {
    @Prop(String)
    private fullPartIds!: string[];
    @Prop(String)
    private partActionLink!: string;
    @Prop({ type: Boolean, default: true })
    private isCloseable!: boolean;

    private relatedPartType: typeof RelatedPartType = RelatedPartType;

    public get isLoading(): boolean {
        return (
            this.$store.getters[
                RelatedPartsModuleTypes.getters.relatedPartsLoadingState
            ] === LoadingState.Loading
        );
    }

    public get visible(): boolean {
        return (
            this.$store.getters[RelatedPartsModuleTypes.getters.partId] &&
            this.fullPartIds.includes(
                this.$store.getters[RelatedPartsModuleTypes.getters.partId]
            )
        );
    }

    public get replacementParts(): RelatedPartEntity[] {
        return this.$store.getters[
            RelatedPartsModuleTypes.getters.replacementParts
        ];
    }

    public get alternativeParts(): RelatedPartEntity[] {
        return this.$store.getters[
            RelatedPartsModuleTypes.getters.alternativeParts
        ];
    }

    public get childBrandParts(): RelatedPartEntity[] {
        return this.$store.getters[
            RelatedPartsModuleTypes.getters.childBrandParts
        ];
    }

    public close(): void {
        this.$store.dispatch(
            RelatedPartsModuleTypes.actions.unloadRelatedParts
        );
    }
}
